export default __webpack_public_path__ + "static/media/01.19.24 Minutes of the Special Meeting of the BOD.c8f34d43.pdf";